module.exports = __webpack_public_path__ + "static/media/image-gallery-9.480aae86.jpg";